// components/RenderGroup.js
import React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { styled } from "@mui/system";

const GroupHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
}));

const GroupItems = styled("ul")({
  padding: 0,
});

const RenderGroup = ({ top100Films }) => {
  const options = top100Films.map((option) => {
    const firstLetter = option.title[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });

  return (
    <Autocomplete
      className="dark:bg-jacarta-700 dropdown-toggle border-jacarta-100 dark:border-jacarta-600 dark:text-jacarta-300 rounded-lg border bg-white text-white show z-50 relative"
      options={options.sort(
        (a, b) => -b.firstLetter.localeCompare(a.firstLetter),
      )}
      groupBy={(option) => option.firstLetter}
      getOptionLabel={(option) => option.title}
      sx={{
        label: {
          color: "white",
        },
        button: {
          color: "white",
        },
        input: {
          color: "white",
        },
      }}
      renderInput={(params) => (
        <TextField {...params} label="Filter Impact Art" />
      )}
      renderGroup={(params) => (
        <li key={params.key}>
          {/* <GroupHeader>{params.group}</GroupHeader> */}
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
    />
  );
};

export default RenderGroup;
